$(document).ready(function() {

  // Variables

  var body  = $('body'),
      main  = $('.main-content'),
      backing = $('.modal-backing');


  // Is the item in the viewport?

  $.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };


  // Jump Links for #

  $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      // On-page links
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
        &&
        location.hostname == this.hostname
      ) {
        // Figure out element to scroll to
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        // Does a scroll target exist?
        if (target.length) {
          // Only prevent default if animation is actually gonna happen
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - 88
          }, 1000, function() {
            // Callback after animation
            // Must change focus!
            var $target = $(target);
            $target.focus();
            if ($target.is(":focus")) { // Checking if the target was focused
              return false;
            } else {
              $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
              $target.focus(); // Set focus again
            };
          });
        }
      }
    });




    // Navigation — Fade Out Siblings

    $( ".social-nav li, .utility-nav li, .site-nav li, .store-link a" ).hover(
      function() {
        $(this).siblings().css('opacity','0.25').css('mix-blend-mode','multiply');
        main.addClass('fade');
      }, function() {
        $(this).siblings().css('opacity','').css('mix-blend-mode','');
        main.removeClass('fade');
      }
    );





    // Lazy Load Images

    function imgTrans() {

      $('.img').each(function(i){

      });

    }




    // Collection Pages

    if ($(body).hasClass('template-collection') || $(body).hasClass('template-product') || $(body).hasClass('template-search')){



        $('.pgi').each(function(i){
          if ($(this).isInViewport()) {

            var pgi = $(this);
              setTimeout(function() {
                pgi.addClass('loaded');

                // var newSrc = pgi.find('.main-img').data('src');
                // pgi.find('.main-img').attr('src',newSrc);
              }, 300*i);
          }
        });

        $(window).on('resize scroll', function() {
          $('.pgi').each(function(i) {
            if ($(this).isInViewport()) {
              var pgi = $(this);
              setTimeout(function() {
                pgi.addClass('loaded');

                // var newSrc = pgi.find('.main-img').data('src');
                // pgi.find('.main-img').attr('src',newSrc);
              }, 300);
            }
          });
        });




    }



    // Product Pages

    if ($(body).hasClass('template-product')){



    }








    // Call Functions

    imgTrans();


    // On Window Resize if Necessary

    $(window).on('resize scroll', function() {

      imgTrans();

    });












});